import * as actionTypes from '../actions/actionTypes';

const initialState={
    ingredients: null,
    totalPrice: 4,
    error:false,
    building:false
}


const reducer=(state=initialState,action)=>{
    let updatedState={...state};
    switch(action.type){
        case actionTypes.DEF_INGREDIENTS:
            updatedState.ingredients={...action.ing};  
            updatedState.totalPrice=4; 
            updatedState.building=false;         
        break;
        case actionTypes.ADD_INGREDIENTS:
        case actionTypes.REM_INGREDIENTS:
            updatedState.building=true;
            updatedState.ingredients={
                salad:action.ing.salad,
                meat:action.ing.meat,
                bacon:action.ing.bacon,
                cheese:action.ing.cheese
            };
            updatedState.totalPrice=action.price;            
        break;
        case actionTypes.DEF_INGREDIENTS_FAILED:
            updatedState.error=true;
            break;        
        default:
    }
    return updatedState;
}

export default reducer;